import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

const Logout = () => {
	const { isFetchingLogout } = useSelector((state) => state.auth);

	return (
		<>
			{isFetchingLogout && (
				<div className="load-logout">
					<Spinner style={{ width: "4rem", height: "4rem" }} className="spinner-logout" animation="border" size="" />
					<span style={{ marginTop: "10px" }}>Cerrando sesión</span>
				</div>
			)}
		</>
	);
};

export default Logout;
